<template>
    <div
        class="w-full py-5 sm:py-6 flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2 items-start"
    >
        <div class="flex-grow space-y-2 text-left">
            <p class="text-sm font-medium ct-text-1">
                {{ section.title }}
            </p>
            <p class="text-sm ct-text-3">
                {{ section.subtitle }}
            </p>
        </div>
        <div class="flex-shrink-0 w-full sm:w-auto flex-col">
            <ButtonSecondaryMd class="w-full sm:w-auto" @click="$emit('ctaAction')">
                <component :is="section.ctaIcon" v-if="section.ctaIcon" />
                <span>{{ section.ctaLabel }}</span>
            </ButtonSecondaryMd>
        </div>
    </div>
</template>

<script>
import { ButtonSecondaryMd } from "@easy/ui/buttons";
import { BulletListIcon, LiveVideoIcon, BookIcon, PrayingHandsIcon } from "@easy/ui/icons";

export default {
    components: {
        ButtonSecondaryMd,
        BulletListIcon,
        LiveVideoIcon,
        BookIcon,
        PrayingHandsIcon,
    },
    props: {
        section: Object,
    },
    emits: ["ctaAction"],
};
</script>
